module.exports = __webpack_public_path__ + "static/img/ten_icon.fdff70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/ten_icon.png
// module id = 7hl1
// module chunks = 12